import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-4 text-lg font-extrabold text-primary" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = { class: "flex items-center gap-4 mb-4" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "" }
const _hoisted_6 = { class: "flex items-center gap-4 mb-4" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = {
  key: 0,
  class: "text-green"
}
const _hoisted_9 = {
  key: 1,
  class: "text-red"
}

import { encryptDecriptMethods } from '@/plugins/encryptDecriptMethods'
import Button from 'primevue/button'
import Card from 'primevue/card'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import ProgressSpinner from 'primevue/progressspinner'
import { onBeforeUnmount, onMounted, onBeforeMount, computed, ref, getCurrentInstance } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import apiUseCase from '@/usecase/apiUseCase'
import Paginator from '@/views/components/paginator/Paginator.vue'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'
import DocumentRequirementForm from './components/forms/DocumentRequirementForm.vue'
import RequirementForm from './components/forms/RequirementForm.vue'

const positionEndpoint = 'talent/v1/positions'

export default /*@__PURE__*/_defineComponent({
  __name: 'Detail',
  setup(__props) {

const store = useStore()
const route = useRoute()
const app = getCurrentInstance()
const {
  $icon
} = app!.appContext.config.globalProperties
const icon = $icon
const data = ref(encryptDecriptMethods.decrypt(route.params.id)) as any
const positionId = ref(data)
const isShowDocumentRequirementForm = ref(false)
const isShowRequirementForm = ref(false)
const documentRequirementList = ref([])
const requirementList = ref([])

const documentFilter = {
  pageNumber: 1,
  pageSize: 10,
  totalRecords: 0,
  search: '',
  filterField: ['documentypeName']
}
const requirementFilter = {
  pageNumber: 1,
  pageSize: 10,
  totalRecords: 0,
  search: '',
  filterField: ['documentypeName']
}
const requirementDummy = [
  { id: 0, name: 'deposit', value: 20000 }
]

const documentRequirementDummy = [
  { id: 0, name: 'KTP', notes: 'xxxxx', isRequired: true },
  { id: 1, name: 'BPJS', notes: 'xxxxx', isRequired: false }
]

const showDocumentRequirementForm = () => {
  isShowDocumentRequirementForm.value = true
}

const hideDocumentRequirementForm = () => {
  isShowDocumentRequirementForm.value = false
}

const showRequirementForm = () => {
  isShowRequirementForm.value = true
}

const hideRequirementForm = () => {
  isShowRequirementForm.value = false
}

const getDocumentRequirementList = async () => {
  store.dispatch('showLoading')
  await apiUseCase.get(`${positionEndpoint}/${positionId.value.id}/documentRequirements${returnUrlPrams(documentFilter)}`).then((response) => {
    console.log('res', response)
    const { error, result } = response
    if (!error) {
      documentFilter.totalRecords = result.length
      documentRequirementList.value = result
    }
  })
  store.dispatch('hideLoading')
}

const getRequirementList = async () => {
  store.dispatch('showLoading')
  await apiUseCase.get(`${positionEndpoint}/${positionId.value.id}/requirements${returnUrlPrams(requirementFilter)}`).then((response) => {
    const { error, result } = response
    if (!error) {
      requirementFilter.totalRecords = result.length
      requirementList.value = result
    }
  })
  store.dispatch('hideLoading')
}

const getAllData = () => {
  getRequirementList()
  getDocumentRequirementList()
}

const onDocumentChangePage = (val: any) => {
  documentFilter.pageNumber = val.page + 1
  getDocumentRequirementList()
}

onMounted(() => {
  store.dispatch('ui/setBreadcrumbs', [
    {
      title: 'Master Divisi',
      routeName: 'master-position'
    },
    {
      title: `Detail Divisi ${data.value.name}`,
      routeName: 'master-position-detail'
    }
  ])
  getAllData()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, "Detail Divisi " + _toDisplayString(positionId.value.name), 1),
    _createVNode(_unref(Card), { class: "card-no-shadow wrap-hjp-data-table mb-4" }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "text-xl font-extrabold" }, "Persyaratan Divisi", -1)),
            _createVNode(_unref(Button), {
              class: "mb-2 btn-primary sm:mb-0 flex gap-2",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (showRequirementForm()))
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", {
                  innerHTML: _unref(icon).svg.plusEva
                }, null, 8, _hoisted_4),
                _cache[2] || (_cache[2] = _createElementVNode("p", { class: "text-white font-bold text-sm" }, _toDisplayString('Tambah Persyaratan Divisi'), -1))
              ]),
              _: 1,
              __: [2]
            })
          ]),
          _createElementVNode("div", null, [
            _createVNode(_unref(DataTable), {
              value: requirementList.value,
              tableStyle: "width: 100%",
              class: "income-detail-table"
            }, {
              empty: _withCtx(() => _cache[4] || (_cache[4] = [
                _createElementVNode("div", { class: "text-grey-4 text-sm italic" }, "Oops, data yang Anda cari tidak ditemukan", -1)
              ])),
              loading: _withCtx(() => [
                _createVNode(_unref(ProgressSpinner), { style: {"width":"70px","height":"70px"} })
              ]),
              default: _withCtx(() => [
                _createVNode(_unref(Column), { header: "NAMA" }, {
                  body: _withCtx((slotProps) => [
                    _createElementVNode("p", null, _toDisplayString(slotProps.data.name), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Column), { header: "NILAI" }, {
                  body: _withCtx((slotProps) => [
                    _createElementVNode("p", null, _toDisplayString(slotProps.data.dataValue ?? '0'), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Column), { header: "" }, {
                  body: _withCtx(() => _cache[5] || (_cache[5] = [
                    _createElementVNode("i", { class: "pi pi-ellipsis-h cursor-pointer" }, null, -1)
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"])
          ])
        ])
      ]),
      footer: _withCtx(() => [
        (requirementFilter.totalRecords > 0)
          ? (_openBlock(), _createBlock(Paginator, {
              key: 0,
              rows: requirementFilter.pageSize,
              totalRecords: requirementFilter.totalRecords,
              onOnPage: onDocumentChangePage
            }, null, 8, ["rows", "totalRecords"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_unref(Card), { class: "card-no-shadow wrap-hjp-data-table mb-4" }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "text-xl font-extrabold" }, "Dokumen Persyaratan", -1)),
            _createVNode(_unref(Button), {
              class: "mb-2 btn-primary sm:mb-0 flex gap-2",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (showDocumentRequirementForm()))
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", {
                  innerHTML: _unref(icon).svg.plusEva
                }, null, 8, _hoisted_7),
                _cache[6] || (_cache[6] = _createElementVNode("p", { class: "text-white font-bold text-sm" }, _toDisplayString('Tambah Dokumen Persyaratan'), -1))
              ]),
              _: 1,
              __: [6]
            })
          ]),
          _createElementVNode("div", null, [
            _createVNode(_unref(DataTable), {
              value: documentRequirementList.value,
              tableStyle: "width: 100%",
              class: "income-detail-table"
            }, {
              empty: _withCtx(() => _cache[8] || (_cache[8] = [
                _createElementVNode("div", { class: "text-grey-4 text-sm italic" }, "Oops, data yang Anda cari tidak ditemukan", -1)
              ])),
              loading: _withCtx(() => [
                _createVNode(_unref(ProgressSpinner), { style: {"width":"70px","height":"70px"} })
              ]),
              default: _withCtx(() => [
                _createVNode(_unref(Column), { header: "NAMA DOKUMEN" }, {
                  body: _withCtx((slotProps) => [
                    _createElementVNode("p", null, _toDisplayString(slotProps.data.documentTypeName), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Column), { header: "KETERANGAN" }, {
                  body: _withCtx((slotProps) => [
                    _createElementVNode("p", null, _toDisplayString(slotProps.data.notes ?? '-'), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Column), { header: "WAJIB" }, {
                  body: _withCtx((slotProps) => [
                    (slotProps.data.isRequired)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_8, _cache[9] || (_cache[9] = [
                          _createElementVNode("i", { class: "pi pi-check" }, null, -1)
                        ])))
                      : (_openBlock(), _createElementBlock("p", _hoisted_9, _cache[10] || (_cache[10] = [
                          _createElementVNode("i", { class: "pi pi-times" }, null, -1)
                        ])))
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Column), { header: "" }, {
                  body: _withCtx(() => _cache[11] || (_cache[11] = [
                    _createElementVNode("i", { class: "pi pi-ellipsis-h cursor-pointer" }, null, -1)
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"])
          ])
        ])
      ]),
      footer: _withCtx(() => [
        (documentFilter.totalRecords > 0)
          ? (_openBlock(), _createBlock(Paginator, {
              key: 0,
              rows: documentFilter.pageSize,
              totalRecords: documentFilter.totalRecords,
              onOnPage: onDocumentChangePage
            }, null, 8, ["rows", "totalRecords"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (isShowDocumentRequirementForm.value)
      ? (_openBlock(), _createBlock(DocumentRequirementForm, {
          key: 0,
          show: isShowDocumentRequirementForm.value,
          positionId: positionId.value,
          onHideForm: hideDocumentRequirementForm,
          onReloadParent: getDocumentRequirementList
        }, null, 8, ["show", "positionId"]))
      : _createCommentVNode("", true),
    (isShowRequirementForm.value)
      ? (_openBlock(), _createBlock(RequirementForm, {
          key: 1,
          show: isShowRequirementForm.value,
          positionId: positionId.value,
          onHideForm: hideRequirementForm,
          onReloadParent: getRequirementList
        }, null, 8, ["show", "positionId"]))
      : _createCommentVNode("", true)
  ]))
}
}

})